import React from "react";
import {QuestionRenderLatex} from "../../atoms/QuestionRenderLatex";

interface QuestionRenderProblemProps {
    problem: string;
}

export default function QuestionRenderProblem({ problem }: QuestionRenderProblemProps) {
    return <QuestionRenderLatex renderString={problem} title={"Условие"} />
}